import React, { Fragment, useMemo } from 'react';

// Components

import SummaryItem from './SummaryItem';

// Utils

import { formatSummaryAddressSecondLine } from '@utils/miscellaneous/formatSummaryAddressSecondLine';

const AddressItem  = props => {

    const {
        customAddressItemProps = undefined,
        isHidden = false,
        textCode,
        streetAddress1,
        streetAddress2,
        city,
        county = null,
        state,
        postalCode,
        addressDescriptors: [
            firstDesc,
            secondDesc,
            thirdDesc
        ] = [],
        getAddressSecondLine = formatSummaryAddressSecondLine,
        isStreetAddress1Hidden = false
    } = props;

    const processedClassNameProps = useMemo(
        () => {
            if (customAddressItemProps) {
                return customAddressItemProps.reduce(
                    (result, propName) => {
                        return {
                            ...result,
                            [propName]: true
                        };
                    },
                    { }
                );
            } else {
                return { addressItemClasses: true };
            }
        },
        [ customAddressItemProps ]
    );

    if(isHidden) {
        return null;
    }

    const streetAddress1SummaryItemId = 'streetAddress1';
    const streetAddress2SummaryItemId = 'streetAddress2';
    const combinedAddressValueSummaryItemId = 'combinedAddressValue';

    const renderLabel = (...args) => {
        const [
            defaultValue,
            {
                registeredSummaryItemsWithDiffs = [],
                summaryItemId = 'someDefaultSummaryItemId'
            },
            areOnlyUpdatedFieldsShown = false
        ] = args;

        const {
            isStreetAddress1HasDiff,
            isStreetAddress2HasDiff,
            isCombinedAddressValueHasDiff,
            isSummaryItemHasDiff
        } = registeredSummaryItemsWithDiffs.reduce((output, item) => {
            let valueToMerge = {};

            switch(item.summaryItemId) {
                case streetAddress1SummaryItemId:
                    valueToMerge = { ...valueToMerge, isStreetAddress1HasDiff: true };
                // eslint-disable-next-line no-fallthrough
                case streetAddress2SummaryItemId:
                    valueToMerge = { ...valueToMerge, isStreetAddress2HasDiff: true };
                // eslint-disable-next-line no-fallthrough
                case combinedAddressValueSummaryItemId:
                    valueToMerge = { ...valueToMerge, isCombinedAddressValueHasDiff: true };
                // eslint-disable-next-line no-fallthrough
                case summaryItemId:
                    valueToMerge = { ...valueToMerge, isSummaryItemHasDiff: true };
            }

            return {
                ...output,
                ...valueToMerge
            };
        }, {
            isStreetAddress1HasDiff: false,
            isStreetAddress2HasDiff: false,
            isCombinedAddressValueHasDiff: false,
            isSummaryItemHasDiff: false
        });

        if(
            areOnlyUpdatedFieldsShown
            && isSummaryItemHasDiff
            && !isStreetAddress1HasDiff
        ) {
            if(
                summaryItemId === streetAddress2SummaryItemId
                && isStreetAddress2HasDiff
            ) {
                return textCode;
            }

            if(
                summaryItemId === combinedAddressValueSummaryItemId
                && isCombinedAddressValueHasDiff
                && !isStreetAddress2HasDiff
            ) {
                return textCode;
            }
        }

        return defaultValue;
    };

    return (
        <Fragment>
            <div className = 'grid-row gi-summary__address' >
                {
                    !isStreetAddress1Hidden
                        ? (
                            <SummaryItem
                                textCode = { textCode }
                                value = { streetAddress1 }
                                ignoreIntl
                                desc = { firstDesc }
                                summaryItemId = { streetAddress1SummaryItemId }
                                { ...processedClassNameProps }
                            />
                        )
                        : null
                }
                {
                    streetAddress2 && streetAddress2.length > 0 &&

                    <SummaryItem
                        category = 'common.no_text'
                        textCode = 'common.no_text'
                        value = { streetAddress2 }
                        ignoreIntl
                        desc = { secondDesc }
                        summaryItemId = { streetAddress2SummaryItemId }
                        renderLabel = { renderLabel }
                        { ...processedClassNameProps }
                    />
                }
                <SummaryItem
                    category = 'common.no_text'
                    textCode = { isStreetAddress1Hidden ? textCode : 'common.no_text' }
                    value = { getAddressSecondLine(city, state, postalCode, county) }
                    ignoreIntl
                    desc = { thirdDesc }
                    summaryItemId = { combinedAddressValueSummaryItemId }
                    renderLabel = { renderLabel }
                    { ...processedClassNameProps }
                />
            </div>
        </Fragment>
    );
};

export default AddressItem;
